module.exports = __webpack_public_path__ + "static/img_1.6fe7c897.jpg";